
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Luxurycabsbookingpune() {



    const cardData =
    {
        keyword: 'Luxury Cabs Booking Pune',
        heading: 'Meghana Cab : Luxury Cabs Booking Pune',
        headingDescription: 'Meghana Cab offers Luxury Cabs Booking in Pune, catering to clients who demand elegance, class, and top-tier comfort for business travel, special events, airport transfers, and outstation trips. Our fleet includes premium vehicles like Innova Crysta, Toyota Fortuner, Mercedes, BMW, and other high-end sedans and SUVs—each offering plush interiors, advanced safety features, and seamless ride quality.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732, Shaniwar Wada was once the grand seat of the Peshwas of the Maratha Empire. Though much of it was destroyed in a fire in 1828, the surviving gates and foundations tell a story of Maratha glory and political intrigue. The Delhi Darwaza (main gate) is especially impressive, and the palace grounds include fountains, courtyards, and the ruins of what was once a seven-storeyed palace. An evening light-and-sound show narrates the fort’s rich history and adds dramatic depth to the visitor experience."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a majestic building with Italian arches and sprawling gardens. Constructed in 1892 to support famine relief efforts, it later became a symbol of India's freedom struggle when Mahatma Gandhi, his wife Kasturba, and his secretary Mahadev Desai were imprisoned here. The palace now houses a museum with rare photos and belongings of the Gandhis, and the serene grounds contain the samadhis of Kasturba Gandhi and Mahadev Desai."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 30 km from Pune, Sinhagad Fort sits atop the Sahyadri Hills at an elevation of 1,317 meters. This ancient hill fortress is most famous for the 1670 Battle of Sinhagad, where Tanaji Malusare fought valiantly for the Marathas. Visitors enjoy panoramic views, rustic food stalls serving bhakri and thecha, and scenic trekking routes. The fort is also dotted with historical points like Tanaji’s memorial and Kalyan Darwaza."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Nestled in Koregaon Park, the Osho Meditation Resort is a globally known center for wellness, meditation, and spiritual healing. Spread across beautifully landscaped gardens and modern zen-style halls, it offers courses in dynamic meditation, therapies, and holistic wellness. It’s not just a spiritual retreat but also a tranquil escape from city life for travelers seeking silence and rejuvenation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved out of a single basalt rock in the 8th century, Pataleshwar Cave Temple is a monolithic shrine dedicated to Lord Shiva. Located in the heart of the city near Jangli Maharaj Road, it features intricately carved pillars, a circular Nandi mandap, and a peaceful atmosphere that contrasts sharply with the urban chaos around it. It is a protected monument under the Archaeological Survey of India."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum houses over 20,000 rare artifacts collected by Dr. Dinkar Kelkar in memory of his son. From musical instruments and weaponry to sculptures and paintings, it showcases India’s rich cultural heritage in a way that’s both educational and immersive. A recent upgrade added multilingual audio guides, making it an excellent experience for all age groups and tourists."
  },
  {
    "title": "Dagadusheth Halwai Ganapati Temple",
    "description": "One of the most revered temples in Pune, Dagadusheth Halwai Ganapati is known for its massive idol of Lord Ganesha, adorned with gold and silver. The temple is particularly festive during Ganesh Chaturthi, when thousands visit to witness the elaborate decorations, music, and bhajan events. Located in the busy Budhwar Peth area, the temple remains a symbol of devotion and community spirit year-round."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Rising 2,100 feet above sea level, Parvati Hill is Pune’s second-highest point and offers a panoramic view of the city. The hill is crowned by a group of ancient temples built during the Peshwa era, including the Devdeveshwar Temple dedicated to Shiva and Parvati. A 103-step climb leads to this peaceful spiritual site, and a small museum nearby offers insight into Peshwa-era history and culture."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
    "description": "Modeled after the famous Okayama Korakuen Garden in Japan, this is one of the largest Japanese-style gardens outside Japan. Spread over 10 acres, it features manicured lawns, natural water flows, elegant bridges, and flower beds that create a peaceful, Zen-like experience. It’s a popular destination for evening walks, photography, and family outings."
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spread across 130 acres, this modern zoological park houses a snake park, zoo, and a rescue center for injured animals. It is home to a wide variety of fauna including leopards, elephants, crocodiles, and Indian cobras. It’s a great educational destination for children and families, with ample greenery and shaded pathways for a relaxed experience."
  }
],

  "services": [
    {
      "name": "Luxury Cab Booking Pune",
      "description": "Experience high-end travel with our luxury cab booking service in Pune. Whether it's for a special occasion, business meeting, or airport transfer, our luxury cabs deliver unmatched elegance, comfort, and professional chauffeur service tailored to your needs."
    },
    {
      "name": "Premium Car Hire Pune",
      "description": "Hire premium cars in Pune for corporate, personal, or event use. Our fleet includes top-tier models like Innova Crysta, Camry, and other executive vehicles that combine sophistication, safety, and class—available for hourly, daily, or custom rentals."
    },
    {
      "name": "Luxury Innova Crysta Cabs Pune",
      "description": "Ride in spacious luxury with our premium Innova Crysta cabs in Pune. Perfect for families, corporate executives, or VIP guests, these cabs feature plush interiors, climate control, generous luggage space, and professionally trained chauffeurs."
    },
    {
      "name": "Executive Car Rental Pune",
      "description": "Choose from our range of executive car rentals in Pune to elevate your corporate travel. Ideal for meetings, client pickups, or outstation travel, our executive fleet is maintained for performance, comfort, and status."
    },
    {
      "name": "Chauffeur Driven Luxury Cabs Pune",
      "description": "Relax and enjoy your journey with our chauffeur-driven luxury cabs in Pune. Each ride comes with an experienced driver trained in corporate etiquette and local routes—making it ideal for executives, NRI guests, or formal events."
    },
    {
      "name": "Online Luxury Cab Booking Pune",
      "description": "Book luxury cabs in Pune online in just a few clicks. Our user-friendly platform offers real-time availability, secure payment options, and instant confirmation—perfect for last-minute bookings or planned occasions."
    },
    {
      "name": "Corporate Luxury Cab Pune",
      "description": "Impress clients and stakeholders with our corporate luxury cab services in Pune. Designed for executives and business travelers, these cabs ensure comfort, punctuality, and a professional experience every time."
    },
    {
      "name": "Family Luxury Car Hire Pune",
      "description": "Make your family trips more comfortable and memorable with our family luxury car hire in Pune. Enjoy ample space, smooth rides, and premium interiors—perfect for weddings, holidays, or airport pickups."
    },
    {
      "name": "Luxury Taxi Service Pune",
      "description": "Upgrade your local travel in Pune with our luxury taxi services. From city tours to hotel transfers, we provide well-maintained, stylish vehicles and courteous drivers to ensure a five-star ride every time."
    },
    {
      "name": "VIP Cab Rental Pune",
      "description": "Our VIP cab rental service in Pune is tailored for celebrities, dignitaries, and high-profile clients. Experience complete privacy, prompt pickups, and a high-standard vehicle equipped with every modern amenity."
    },
    {
      "name": "High-End Car Rental Pune",
      "description": "Choose from our selection of high-end car rentals in Pune for an elite travel experience. Whether for a photoshoot, event, or premium commute, our fleet includes the best-in-class vehicles to match your style."
    },
    {
      "name": "Luxury Airport Transfer Pune",
      "description": "Arrive in style or leave with comfort using our luxury airport transfer services in Pune. Our chauffeurs track your flight, assist with luggage, and ensure a timely, smooth ride in a fully air-conditioned, spacious vehicle."
    },
    {
      "name": "Comfortable Luxury Cabs Pune",
      "description": "Our comfortable luxury cabs in Pune are designed to offer a smooth and stress-free travel experience. Enjoy plush seating, ample legroom, rear AC vents, and a calm ambiance whether you’re going short-distance or intercity."
    },
    {
      "name": "Affordable Luxury Taxi Pune",
      "description": "Travel in style without overspending. Our affordable luxury taxi service in Pune offers a premium ride experience at competitive rates—great for special occasions, business needs, or anyone who values comfort and class."
    },
    {
      "name": "Premium Chauffeur Service Pune",
      "description": "Enjoy a VIP experience with our premium chauffeur service in Pune. Whether for daily use, business travel, or events, our professionally dressed chauffeurs ensure discreet, polite, and reliable service tailored to your expectations."
    }
  ],
  "tableData": [
    ["Luxury Cab Booking Pune", "Premium Car Hire Pune"],
    ["Luxury Innova Crysta Cabs Pune", "Executive Car Rental Pune"],
    ["Chauffeur Driven Luxury Cabs Pune", "Online Luxury Cab Booking Pune"],
    ["Corporate Luxury Cab Pune", "Family Luxury Car Hire Pune"],
    ["Luxury Taxi Service Pune", "VIP Cab Rental Pune"],
    ["High-End Car Rental Pune", "Luxury Airport Transfer Pune"],
    ["Comfortable Luxury Cabs Pune", "Affordable Luxury Taxi Pune"],
    ["Premium Chauffeur Service Pune", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Premium Luxury Cabs for Travel in and Around Pune",
    "WhyChoosedescription": "Experience top-tier comfort and class with our luxury cab booking services in Pune. Whether you're heading to a business meeting, airport, special event, or outstation destination, our luxury cars offer unmatched elegance and a premium travel experience."
  },
  {
    "WhyChooseheading": "Fleet of High-End Vehicles",
    "WhyChoosedescription": "Choose from a range of luxury cars including Toyota Innova Crysta, Toyota Camry, BMW, Audi, and Mercedes-Benz. Each vehicle is equipped with plush interiors, advanced features, and high safety standards to ensure a first-class ride every time."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs for Executive Service",
    "WhyChoosedescription": "Our well-trained chauffeurs offer discreet, courteous service and are dressed professionally. They are punctual, route-savvy, and trained to provide a smooth and refined ride for VIPs, corporates, and elite clientele."
  },
  {
    "WhyChooseheading": "Perfect for Business, Weddings, VIP Guests & Events",
    "WhyChoosedescription": "From corporate transfers and luxury wedding arrivals to airport pickups for international guests, our luxury cabs are designed for occasions that demand style, comfort, and precision."
  },
  {
    "WhyChooseheading": "Fully Sanitized, Well-Maintained Vehicles",
    "WhyChoosedescription": "Our luxury fleet is cleaned and sanitized before every ride. We follow strict maintenance protocols to ensure vehicles are in pristine condition, combining elegance with peace of mind for our clients."
  },
  {
    "WhyChooseheading": "Flexible Booking for Hourly, Daily, or Outstation Use",
    "WhyChoosedescription": "Book a luxury cab for short trips within Pune, full-day usage, or extended outstation travel. We offer flexible packages to match your travel needs, with customized itineraries and multiple stop options."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "All our pricing is upfront and inclusive of driver charges, fuel, and tolls. Enjoy luxury service with no surprises—just smooth billing and top-quality comfort at competitive rates."
  },
  {
    "WhyChooseheading": "24/7 Support and Priority Bookings",
    "WhyChoosedescription": "Our team is available 24/7 for reservations, modifications, or urgent bookings. We prioritize luxury clients with fast confirmations and support tailored to personal or corporate preferences."
  }
]



























    }

const faqData = [
    {
        question: "How can I book luxury cabs in Pune?",
        answer: "You can book luxury cabs by calling Meghana Cab at +91 9075462128 or through our website for quick and easy reservations."
    },
    {
        question: "What types of luxury cabs are available for booking in Pune?",
        answer: "We offer a variety of luxury cabs including Innova Crysta, Audi, Mercedes, and other premium vehicles."
    },
    {
        question: "Are luxury cabs available for airport transfers in Pune?",
        answer: "Yes, luxury cabs can be booked for both pickup and drop services to Pune Airport."
    },
    {
        question: "Can I book luxury cabs for corporate travel?",
        answer: "Absolutely, we provide luxury cab services tailored for corporate clients and business meetings."
    },
    {
        question: "Is the luxury cab service available 24/7 in Pune?",
        answer: "Yes, Meghana Cab offers round-the-clock luxury cab services."
    },
    {
        question: "Are the luxury cabs sanitized before every ride?",
        answer: "Yes, all luxury vehicles are thoroughly sanitized before each trip for your safety."
    },
    {
        question: "What is the seating capacity of luxury cabs?",
        answer: "Depending on the model, luxury cabs seat between 4 to 7 passengers comfortably."
    },
    {
        question: "Can I customize my luxury cab booking with stops or detours?",
        answer: "Yes, customized stops and routes can be arranged. Please inform us at the time of booking."
    },
    {
        question: "What payment methods are accepted for luxury cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How do I contact Meghana Cab for luxury cab inquiries?",
        answer: "You can call us anytime at +91 9075462128 or visit our website for more information."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Sandeep Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booking a luxury cab in Pune with Meghana Cab was seamless. The car was elegant and the driver professional.”',
    },
    {
        name: 'Ms. Kavita Sharma',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I loved the luxury cab service for my corporate travel. Comfortable ride and impeccable service.”',
    },
];

























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];











const luxuryCabsSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Luxury Cabs Booking in Pune",
  "description": "Premium chauffeur-driven luxury cab service in Pune. Ideal for corporate travel, family trips, airport transfers, and special occasions. Comfortable, affordable, and reliable luxury car hire.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Luxury Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/luxury-cab-booking-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Luxury Cabs Booking in Pune | Premium & Executive Car Hire</title>
  <meta
    name="description"
    content="Book premium chauffeur-driven luxury cabs in Pune for corporate travel, family trips, airport transfers, and special occasions. Affordable and reliable luxury taxi service."
  />
  <meta
    name="keywords"
    content="Luxury Cab Booking Pune, Premium Car Hire Pune, Luxury Innova Crysta Cabs Pune, Executive Car Rental Pune, Chauffeur Driven Luxury Cabs Pune, Online Luxury Cab Booking Pune, Corporate Luxury Cab Pune, Family Luxury Car Hire Pune, Luxury Taxi Service Pune, VIP Cab Rental Pune, High-End Car Rental Pune, Luxury Airport Transfer Pune, Comfortable Luxury Cabs Pune, Affordable Luxury Taxi Pune, Premium Chauffeur Service Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(luxuryCabsSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/24.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Luxurycabsbookingpune;